@if (selectedBluePrintEdge) {
<div class="div-right-panel-component">
  <form #myForm="ngForm">
    <fieldset [disabled]="isReadOnly" style="border: none; padding: 0; margin: 0">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput #inputName required (focus)="selectName()" (keyup)="onChange()" maxlength="255" type="text" [(ngModel)]="selectedBluePrintEdge.name" name="selectedBluePrintEdge.name" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput (focusout)="onChange()" [(ngModel)]="selectedBluePrintEdge.description" name="selectedBluePrintEdge.description"></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.label" name="selectedBluePrintEdge.label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Relationship Type</mat-label>
        <mat-select required [(ngModel)]="selectedBluePrintEdge.relationshipType" name="relationshipType">
          @for (type of blueprintRelationshipTypes; track type) {
          <mat-option [value]="type">{{ type }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Select source</mat-label>
        <mat-select required [(ngModel)]="selectedSource" (ngModelChange)="sourceSelectionChanged()" name="selectedSource">
          <mat-option value="rootnode">Root item</mat-option>
          @for (node of availableSources; track node) {
          <mat-option [value]="node.key">{{ node.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Select targets</mat-label>
        <mat-select required [(ngModel)]="selectedTargets" (ngModelChange)="targetSelectionChanged()" multiple name="selectedTargets">
          @for (node of availableTargets; track node) {
          <mat-option [value]="node.key">{{ node.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Source label</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.sourceLabel" name="selectedBluePrintEdge.sourceLabel" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Target label</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.targetLabel" name="selectedBluePrintEdge.targetLabel" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Edge strength</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.edgeStrength" name="selectedBluePrintEdge.edgeStrength" />
      </mat-form-field>
      <mat-form-field *ngIf="selectedBluePrintEdge?.edgeDisplay">
        <mat-label>Line style</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.edgeDisplay.lineStyle" name="lineStyle" />
      </mat-form-field>
      <mat-form-field *ngIf="selectedBluePrintEdge?.edgeDisplay">
        <mat-label>Line color</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.edgeDisplay.lineColor" name="lineColor" />
      </mat-form-field>
      <mat-form-field *ngIf="selectedBluePrintEdge?.edgeDisplay">
        <mat-label>Line weight</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.edgeDisplay.lineWeight" name="lineWeight" />
      </mat-form-field>
      <mat-form-field *ngIf="selectedBluePrintEdge?.edgeDisplay">
        <mat-label>Line source arrow</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.edgeDisplay.sourceArrow" name="sourceArrow" />
      </mat-form-field>
      <mat-form-field *ngIf="selectedBluePrintEdge?.edgeDisplay">
        <mat-label>Line target arrow</mat-label>
        <input matInput type="text" [(ngModel)]="selectedBluePrintEdge.edgeDisplay.targetArrow" name="targetArrow" />
      </mat-form-field>
    </fieldset>
    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.form.valid || !myForm.form.dirty">Save</button>
    </div>
  </form>
</div>
}
